import React, { CSSProperties } from 'react';
import blazeDataIcon from '../../images/blaze-data.svg';

type BlazeDataIconProps = {
  /**
   * Height in pixels; width scales to preserve aspect ratio.
   */
  size?: number;
  title?: string;
  className?: string;
  style?: CSSProperties;
};

const BlazeDataIcon = ({ size = 16, title, className, style }: BlazeDataIconProps) => (
  <span className={className} style={style} title={title} aria-hidden={true}>
    <img src={blazeDataIcon} alt="" height={size} />
  </span>
);

export default BlazeDataIcon;
